import { render, staticRenderFns } from "./studentReport.vue?vue&type=template&id=4f2241d4&scoped=true"
import script from "./studentReport.vue?vue&type=script&lang=js"
export * from "./studentReport.vue?vue&type=script&lang=js"
import style0 from "./studentReport.vue?vue&type=style&index=0&id=4f2241d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2241d4",
  null
  
)

export default component.exports